import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';
import { FC, ReactNode } from 'react';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { TypographyTypeMap } from '@mui/material/Typography/Typography';

const StyledTitle = styled(Typography)({
  fontSize: '28px',
  lineHeight: '32px',
  textTransform: 'capitalize',
  fontWeight: 600,
  '@media (max-width: 600px)': {
    fontSize: '20px',
  },
}) as OverridableComponent<TypographyTypeMap>;

type TBaseHeader = {
  children: ReactNode
};

const BaseHeader: FC<TBaseHeader> = ({ children }) => (
  <StyledTitle component="div">
    <div>{children}</div>
  </StyledTitle>
);

export {
  BaseHeader,
};
